import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

/** 支付管理代码加载时保留默认银行转账的信息步骤，不提前展示打款表单 */
export function PaymentManagementSkeleton() {
  return (
    <div className="p-6 pt-0 space-y-6" aria-hidden="true">
      {/** 页面标题和预付订单入口 */}
      <div className="flex items-center justify-between">
        <Skeleton className="h-9 w-48" />
        <div className="flex gap-2">
          <Skeleton className="h-9 w-24" />
        </div>
      </div>

      <Card className="min-w-[1000px]">
        {/** 付款账户和收款账户名称 */}
        <CardHeader className="pb-4">
          <div className="flex w-full gap-10">
            {Array.from({ length: 2 }, (_, index) => (
              <div key={index} className="flex items-center flex-1 gap-4">
                <Skeleton className="h-4 w-24 shrink-0" />
                <Skeleton className="h-9 flex-1" />
              </div>
            ))}
          </div>
        </CardHeader>

        <CardContent>
          <div className="flex w-full gap-10">
            {/** 初始银行列表尚未返回，保留支付方式和提示区位置 */}
            <div className="flex flex-col flex-1 border rounded-lg bg-card/50 overflow-hidden h-[580px]">
              <div className="flex-1 overflow-hidden p-4">
                <div className="space-y-4">
                  <div className="space-y-4">
                    <Skeleton className="h-7 w-28" />
                    <Skeleton className="h-5 w-14" />
                  </div>
                  <div className="flex w-fit items-stretch">
                    <Skeleton className="h-9 w-28 rounded-r-none" />
                    <Skeleton className="h-9 w-28 rounded-l-none" />
                  </div>
                  <div className="space-y-4 pt-2">
                    <div className="pt-2">
                      <div className="h-5">
                        <Skeleton className="h-4 w-14" />
                      </div>
                      {Array.from({ length: 3 }, (_, index) => (
                        <div key={index}>
                          <div className="h-5">
                            <Skeleton className="h-4 w-full" />
                          </div>
                          <div className="h-5">
                            <Skeleton className="h-4 w-4/5" />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/** 银行转账账户信息及底部下一步入口 */}
            <div className="flex flex-col flex-1 border rounded-lg bg-card/50 h-[580px] overflow-hidden text-[14px]">
              <div className="p-4 pb-4 pl-6 shrink-0 bg-card/50">
                <Skeleton className="h-7 w-44" />
              </div>
              <div className="flex-1 overflow-hidden px-6">
                <div className="border-t border-gray-100">
                  {Array.from({ length: 7 }, (_, index) => (
                    <div key={index} className="flex py-4 border-b border-gray-100">
                      <div className="w-32 shrink-0">
                        <Skeleton className="h-5 w-20" />
                      </div>
                      <div className="flex flex-1 justify-end">
                        <Skeleton className="h-5 w-32 max-w-full" />
                      </div>
                    </div>
                  ))}
                </div>
                <div className="mt-6 flex justify-center pb-4">
                  <Skeleton className="h-5 w-80 max-w-full" />
                </div>
              </div>
              <div className="p-4 pr-6 shrink-0 flex justify-end bg-card/50 shadow-inner">
                <Skeleton className="h-9 w-32" />
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
